
<template>
    <div class="text-item" id="AreaSelect" @touchmove.prevent>
        <div  @click="switchFn">
            {{areaText}}
        </div>
        <div v-transfer-dom id="AreaSelectModel">
            <popup v-model="show" position="bottom" height="50%">
                <!-- group already has a top border, so we need to hide header's bottom border-->
                <popup-header
                    right-text="关闭"
                    title="请选择地区"
                    :show-bottom-border="false"
                    @on-click-right="show = false"
                >
                </popup-header>
                <div class="checkTab vux-1px-b">
                    <a v-for="(item,index) in catchArea" @click="changeArea(index)" href="javascript:;">{{item.name}}</a>
                </div>
                <ul class="list">
                    <li class="vux-1px-b" @click="liChangeArea(li)" v-for="(li,i) in list">{{li.name}}</li>
                </ul>
            </popup>
        </div>
    </div>
</template>
<script>

import  Group  from 'vux/src/components/group/index.vue'
import  PopupHeader  from 'vux/src/components/popup-header/index.vue'
import  Panel  from 'vux/src/components/panel/index.vue'
import  Popup  from 'vux/src/components/popup/index.vue'
import  TransferDom  from 'vux/src/directives/transfer-dom/index.js'

export default {
    directives: {
        TransferDom
    },
    data:function(){
        return {
            globalRegions:window.globalRegions,
            provinceData:window.provinceData,
            show:false,
            checkIndex:0,
            catchArea:[{name:'请选择',id:''}],
            list:[],
        }
    },
    mounted(){
        this.changeArea(0);
    },
    props:{
        value: {
            type: Array,
            default () {
                return []
            }
        },
    },
    computed:{
        currentValue:function(){

        },
        areaText:function(){
            let _Vm=this
            if(this.value&&this.value.length>=3){
                let str='';
                _Vm.value.forEach((item,index) => {
                    console.log(index)
                    if(index==0){
                        str+=_Vm.getData(-1,item).name+'  '
                    }else{
                        str+=_Vm.getData(_Vm.value[index-1],item).name+'  '
                    }
                    
                });
                
                return  str
            }else{
                return '地区信息'
            }
        }
    },
    watch:{
        'value':function(cval){

        }
    },
    methods:{
        switchFn() {
            this.show = true;
            document.body.scrollTop = 0;
            window.screenTop = 0;
        },
        getData(key,id){
            var _obj={}
            this.globalRegions[key].forEach(item => {
                if(item.id==id){
                    _obj=item
                }
            });
            return _obj
        },
        changeArea(ji){
            this.checkIndex=ji;
            this.catchArea.length=ji+1;
            this.catchArea[this.checkIndex]={'name':'请选择',id:''};
            if(this.checkIndex==0){
                this.list=this.provinceData;
            }else{
                let _parent_id=this.catchArea[this.checkIndex-1].id
                this.list=this.globalRegions[_parent_id];
            }
            document.querySelector('.list').scrollTop = 0
        },
        liChangeArea(li){
            this.catchArea[this.checkIndex]=li;
            var _list=this.globalRegions[li.id];
            if(_list&&_list.length){
                this.catchArea.push({'name':'请选择',id:''})
                this.checkIndex=this.checkIndex+1;
                this.list=this.globalRegions[li.id];
            }else{
                var _value=[];
                this.catchArea.forEach(item=>{
                    _value.push(item.id.toString())
                })
                this.show=false;
                this.$emit('input', _value);
                this.$emit('on-enterArea', this.catchArea);
            }
            document.querySelector('.list').scrollTop = 0
        }
    },
    components: {
        Panel,
        PopupHeader,
        Popup,
    }
}

</script>
<style lang="less">
@import '~vux/src/styles/1px.less';
</style>
<style lang="scss">
$pole:75;
#AreaSelectModel{
    .checkTab{
        height: 1.17333rem;
        font-size: 0.42667rem;
        line-height: 1.17333rem;
        color: #333;
        background: #fff;
        a{
            margin:0 10rem/$pole;
        }
    }
    ul.list{
        background: #fff;
        font-size: 0.42667rem;
        line-height: 1.17333rem;
        position: absolute;
        top: 2.34666rem;
        left: 0;
        color: #666;
        bottom: 0;
        overflow-y: auto;
        width: 100%;

        li{
            height: 1.17333rem;
            padding-left:10rem/$pole;
        }
    }
}
</style>